function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { pcaa } from '@/components/_util/area-data';
import Area from '@/components/_util/Area';
export default {
  name: 'JAreaLinkage',
  props: {
    value: {
      type: String,
      required: false
    },
    // 组件的类型，可选值：
    // select 下拉样式
    // cascader 级联样式（默认）
    type: {
      type: String,
      default: 'cascader'
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      pcaa: pcaa,
      innerValue: [],
      usedListeners: ['change'],
      enums: {
        type: ['cascader', 'select']
      },
      reloading: false,
      areaData: ''
    };
  },
  computed: {
    _listeners: function _listeners() {
      var listeners = _objectSpread({}, this.$listeners);
      // 去掉已使用的事件，防止冲突
      this.usedListeners.forEach(function (key) {
        delete listeners[key];
      });
      return listeners;
    },
    _type: function _type() {
      if (this.enums.type.includes(this.type)) {
        return this.type;
      } else {
        console.error("JAreaLinkage\u7684type\u5C5E\u6027\u53EA\u80FD\u63A5\u6536\u6307\u5B9A\u7684\u503C\uFF08".concat(this.enums.type.join('|'), "\uFF09"));
        return this.enums.type[0];
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        this.loadDataByValue(this.value);
      }
    }
  },
  created: function created() {
    this.initAreaData();
  },
  methods: {
    /** 重新加载组件 */reload: function reload() {
      var _this = this;
      this.reloading = true;
      this.$nextTick(function () {
        return _this.reloading = false;
      });
    },
    /** 通过 value 反推 options */loadDataByValue: function loadDataByValue(value) {
      if (!value || value.length === 0) {
        this.innerValue = [];
      } else {
        this.initAreaData();
        var arr = this.areaData.getRealCode(value);
        this.innerValue = arr;
      }
      this.reload();
    },
    /** 通过地区code获取子级 */loadDataByCode: function loadDataByCode(value) {
      var options = [];
      var data = pcaa[value];
      if (data) {
        for (var key in data) {
          if (data.hasOwnProperty(key)) {
            options.push({
              value: key,
              label: data[key]
            });
          }
        }
        return options;
      } else {
        return [];
      }
    },
    /** 判断是否有子节点 */hasChildren: function hasChildren(options) {
      var _this2 = this;
      options.forEach(function (option) {
        var data = _this2.loadDataByCode(option.value);
        option.isLeaf = data.length === 0;
      });
    },
    handleChange: function handleChange(values) {
      var value = values[values.length - 1];
      this.$emit('change', value);
    },
    initAreaData: function initAreaData() {
      if (!this.areaData) {
        this.areaData = new Area();
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
};